let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1PJIF")).then(() => parcelRequire('5pz6a'));